import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import FunctionCloneDeep from "radium-omnibus";
import ContainerContent from "../../components/Layout/ContainerContent";
import { successAlert } from "../../components/Modals/successAlert";
import api from "../../api";
import { ToastContainer } from "react-toastify";
import { FunctionUploadFileAws } from "../../utils/useFunctions";

import { optionsPayMent } from "../../constrant/optionscommon";
import {
  districtOption,
  postcodeOption,
  subDistrictOption,
  provinceOption,
} from "../../utils/option.util";
import MultiSelect from "../../components/Multiselect";
import SingleSelect from "../../components/Singleselect";
import { getImgSrc, getPathUrl } from "../../function";
import _ from "lodash";

const AddCradle = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [thisId, setThisId] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const id = params?.id;
  const [carTypes, setCarTypes] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [cradletypes, setCradletype] = useState([]);
  // const [form, setForm] = useState({});
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredSubDistricts, setFilteredSubDistricts] = useState([]);
  const [filteredPostcodes, setFilteredPostcodes] = useState([]);

  const loadAll = useCallback(async () => {
    await fetchCarTypes();
    await fetchInsurances();
    await fetCradletypes();
    // eslint-disable-next-line
  }, []);

  const LoadData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/cradles/${thisId}`);

      const mapcradle = await mappingData(data?.cradle);
      if (data.cradle?.province) {
        const selectedProvince = provinceOption?.find(
          (option) => option?.value === data.cradle?.province
        );
        setFilteredDistricts(
          districtOption?.filter(
            (item) => item?.province_code === selectedProvince?.province_code
          )
        );
      }
      if (data.cradle?.district) {
        const selectedDistrict = districtOption?.find(
          (option) => option?.value === data.cradle?.district
        );
        setFilteredSubDistricts(
          subDistrictOption?.filter(
            (item) => item?.district_code === selectedDistrict?.district_code
          )
        );
      }
      if (data.cradle?.sub_district) {
        const selectedSubDistrict = subDistrictOption?.find(
          (option) => option?.value === data.cradle?.sub_district
        );
        setFilteredPostcodes(
          postcodeOption?.filter(
            (item) =>
              item?.sub_district_code === selectedSubDistrict?.sub_district_code
          )
        );

        console.log("filteredPostcodeszzzzz", filteredPostcodes);
      }

      setData(mapcradle);
    } catch (error) {
      console.log("ERROR TO LOAD CRADLE :", error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [thisId, cradletypes]);

  useEffect(() => {
    loadAll();
    if (params.id) {
      const thisPath = params.id;
      setThisId(thisPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, loadAll]);

  useEffect(() => {
    if (thisId) {
      LoadData();
    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thisId, cradletypes, LoadData]);

  // สร้าง state สำหรับฟอร์ม (ย้ายออกมาไว้ก่อน return และไม่อยู่ในเงื่อนไข)
  const [form, setForm] = useState({
    member_no: "",
    cradle_name: "",
    telephone: "",
    fax: "",
    email: "",
    line: "",
    facebook: "",
    website: "",
    working_day: [],
    start_date: "",
    end_date: "",
    description: "",
    other_service: "",
    location: "",
    travel: "",
    facilities: "",
    moredetails: "",
    map_cradle: "",
    cradle_types: [],
    car_types: [],
    insurances: [],
    province: null,
    district: null,
    sub_district: null,
    postcode: null,
    address: "",
    cradle_image_cover: null,
    images_gallery: [],
  });

  console.log("form", form);

  // เมื่อ data เปลี่ยน ให้ sync ค่าเข้า form
  useEffect(() => {
    setForm({
      member_no: data?.member_no || "",
      cradle_name: data?.cradle_name || "",
      telephone: data?.telephone || "",
      fax: data?.fax || "",
      email: data?.email || "",
      line: data?.line || "",
      facebook: data?.facebook || "",
      website: data?.website || "",
      working_day: data?.working_day || [],
      start_date: data?.start_date || "",
      end_date: data?.end_date || "",
      description: data?.description || "",
      other_service: data?.other_service || "",
      location: data?.location || "",
      travel: data?.travel || "",
      facilities: data?.facilities || "",
      moredetails: data?.moredetails || "",
      map_cradle: data?.map_cradle || "",
      cradle_types: data?.cradle_types || [],
      car_types: data?.car_types || [],
      insurances: data?.insurances || [],
      province: data?.province || null,
      district: data?.district || null,
      sub_district: data?.sub_district || null,
      postcode: data?.postcode || null,
      address: data?.address || "",
      cradle_image_cover: data?.cradle_image_cover || null,
      images_gallery:
        data?.images_gallery?.map((row) => ({ this_images_gallery: row })) ||
        [],
    });
  }, [data]);

  // load
  const mappingData = async (cradle) => {
    console.log("cradle", cradle);
    return {
      ...cradle,
      working_day: cradle?.working_day?.map((option) => {
        return option_days?.find(
          (option_days) => option_days?.value === option
        );
      }),
      start_date: cradle?.start_date || "",
      end_date: cradle?.end_date || "",

      cradle_types: cradle?.cradle_types?.map((option) => {
        return cradletypes?.find(
          (cradle_types) => cradle_types?.value === option
        );
      }),

      car_types: cradle?.car_types?.map((option) => {
        return carTypes?.find((car_type) => car_type?.value === option);
      }),

      payment_types: cradle?.payment_types?.map((option) => {
        return optionsPayMent?.find(
          (optionsPayMent) => optionsPayMent?.value === option
        );
      }),

      insurances: cradle?.insurances?.map((option) => {
        return insurances?.find((insurances) => insurances?.value === option);
      }),
      // province: provinceOption?.find(
      //   (option) => cradle?.province === option?.value
      // ),
      // district: districtOption?.find(
      //   (option) => cradle?.district === option?.value
      // ),
      // sub_district: subDistrictOption?.find(
      //   (option) => cradle?.sub_district === option?.value
      // ),
      // postcode: postcodeOption?.find(
      //   (option) => parseInt(cradle?.postcode) === parseInt(option?.value)
      // ),

      // address: address?.find((option) => cradle?.address === option?.value),
    };
  };

  const fetCradletypes = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/cradletypes`);
      setCradletype(
        data?.cradletypes?.map((cradletypes) => {
          return {
            value: cradletypes._id,
            label: cradletypes.cradletype_name,
          };
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchCarTypes = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/cartypes`);
      setCarTypes(
        data?.cartypes?.map((cartype) => {
          return {
            value: cartype._id,
            label: cartype.cartype_name,
          };
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const option_days = [
    { value: "MONDAY", label: "จันทร์" },
    { value: "TUESDAY", label: "อังคาร" },
    { value: "WEDNESDAY", label: "พุธ" },
    { value: "THURSDAY", label: "พฤหัสบดี" },
    { value: "FRIDAY", label: "ศุกร์" },
    { value: "SATURDAY", label: "เสาร์" },
    { value: "SUNDAY", label: "อาทิตย์" },
  ];

  const fetchInsurances = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/insurances`);
      setInsurances(
        data?.insurances?.map((insurance) => {
          return {
            value: insurance._id,
            label: insurance.insurance_name,
          };
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getMappingForm = (form) => {
    return {
      ...form,
      cradle_types: form?.cradle_types?.map(
        (cradle_type) => cradle_type?.value
      ),
      car_types: form?.car_types?.map((car_type) => car_type?.value),
      insurances: form?.insurances?.map((insurance) => insurance?.value), // [string]
      working_day: form?.working_day?.map((working_day) => working_day?.value),
      description: form?.description,
      other_service: form?.other_service,
      map_cradle: form?.map_cradle,
      payment_types: form?.payment_types?.map(
        (payment_type) => payment_type?.value
      ),
    };
  };

  const onClickSubmit = async (form) => {
    let newForm = _.cloneDeep(form);

    newForm = {
      ...newForm,
      images_gallery: await Promise.all(
        form?.images_gallery?.map(async (image) => {
          console.log("image ", image);
          if (image?.this_images_gallery) {
            const thisImageKeyS3 = await FunctionUploadFileAws(
              image?.this_images_gallery
            );
            return thisImageKeyS3;
          } else {
            return;
          }
        })
      ),
    };

    console.log("form", newForm);

    try {
      // 1

      if (thisId) {
        // let cradle01_key = null;
        // if (form) {
        //   cradle01_key = await FunctionUploadFileAws(form.cradle_image_cover);
        // }
        await api.put(`/cradles/${thisId}`, {
          ...newForm,
          ...getMappingForm(newForm),
          cradle_image_cover: await FunctionUploadFileAws(
            newForm.cradle_image_cover
          ),
        });
        setTimeout(() => {
          navigate("/cradle");
        }, 3000);
        // notifySuccess();
      } else {
        await api.post("/cradles", {
          ...newForm,
          ...getMappingForm(newForm),
          cradle_image_cover: await FunctionUploadFileAws(
            newForm.cradle_image_cover
          ),
        });

        successAlert();
        setTimeout(() => {
          navigate("/cradle");
        }, 3000);
      }
    } catch (error) {
      console.log("error", error);
      alert("เกิดข้อผิดพลาด " + error);
    }
  };

  // console.log("LOAD DATAA ", { data, thisLoadData });

  if (loading) {
    return <div>Loading...</div>;
  }

  // handle change สำหรับ input ทั่วไป
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // handle change สำหรับ select/multi-select
  const handleSelectChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // handle file input
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "images_gallery") {
      setForm((prev) => ({
        ...prev,
        images_gallery: Array.from(files)?.map((file) => ({
          this_images_gallery: file,
        })),
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: files?.[0] }));
    }
  };

  // handle เพิ่ม/ลบ images_gallery
  const handleAddGallery = () => {
    setForm((prev) => ({
      ...prev,
      images_gallery: [...prev?.images_gallery, { this_images_gallery: null }],
    }));
  };
  const handleRemoveGallery = (idx) => {
    setForm((prev) => ({
      ...prev,
      images_gallery: prev?.images_gallery?.filter((_, i) => i !== idx),
    }));
  };
  const handleGalleryFileChange = (idx, file) => {
    setForm((prev) => {
      const newGallery = [...prev?.images_gallery];
      newGallery[idx] = { this_images_gallery: file };
      return { ...prev, images_gallery: newGallery };
    });
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    await onClickSubmit(form);
  };

  // handle cancel
  const handleCancel = () => {
    navigate("/cradle");
  };

  console.log("form", form);

  return (
    <ContainerContent>
      <ToastContainer />
      <div className=" pl-72 text-2xl text-gray font-normal flex gap-2 items-center  ">
        <div className="border-2 border-darkgray rounded-full flex justify-center p-2 w-32">
          Create {""}
        </div>
      </div>
      <div className=" pl-72 my-10">
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-3 items-center justify-center"
        >
          <div className="w-full">
            <label className="textgray font-light mb-2">เลขที่สมาชิก</label>
            <input
              name="member_no"
              type="text"
              value={form?.member_no}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">ชื่ออู่</label>
            <input
              name="cradle_name"
              type="text"
              value={form.cradle_name}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">ช่องทางติดต่อ</label>
            <input
              name="telephone"
              type="text"
              value={form.telephone}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">fax</label>
            <input
              name="fax"
              type="text"
              value={form.fax}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">email</label>
            <input
              name="email"
              type="text"
              value={form.email}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">line</label>
            <input
              name="line"
              type="text"
              value={form.line}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">facebook</label>
            <input
              name="facebook"
              type="text"
              value={form.facebook}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">website</label>
            <input
              name="website"
              type="text"
              value={form.website}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          {/* working_day multi-select */}
          <div className="w-full">
            <label className="textgray font-light mb-2">
              เลือกวันทำงาน (เลือกได้มากกว่า 1)
            </label>

            <MultiSelect
              option={option_days}
              onChange={(selectedOptions) => {
                handleSelectChange("working_day", selectedOptions);
              }}
              value={form?.working_day}
            />
          </div>
          {/* start_date, end_date */}
          <div className="w-full">
            <label className="textgray font-light mb-2">เวลาเริ่มงาน</label>
            <input
              name="start_date"
              type="text"
              value={form.start_date}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">เวลาเลิกงาน</label>
            <input
              name="end_date"
              type="text"
              value={form.end_date}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">คำอธิบาย</label>
            <input
              name="description"
              type="text"
              value={form.description}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">บริการอื่นๆ</label>
            <input
              name="other_service"
              type="text"
              value={form.other_service}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">สถานที่ตั้ง</label>
            <input
              name="location"
              type="text"
              value={form.location}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">การเดินทาง</label>
            <input
              name="travel"
              type="text"
              value={form.travel}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">
              สิ่งอำนวยความสะดวก
            </label>
            <input
              name="facilities"
              type="text"
              value={form.facilities}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">
              รายละเอียดเพิ่มเติม
            </label>
            <input
              name="moredetails"
              type="text"
              value={form.moredetails}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">ตำแหน่งที่ตั้ง</label>
            <input
              name="map_cradle"
              type="text"
              value={form.map_cradle}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          {/* cradle_types multi-select */}
          <div className="w-full">
            <label className="textgray font-light mb-2">ประเภทอู่</label>

            <MultiSelect
              option={cradletypes}
              onChange={(selectedOptions) => {
                handleSelectChange("cradle_types", selectedOptions);
              }}
              value={form?.cradle_types}
            />
          </div>
          {/* car_types multi-select */}
          <div className="w-full">
            <label className="textgray font-light mb-2">ประเภทรถ</label>

            <MultiSelect
              option={carTypes}
              onChange={(selectedOptions) => {
                handleSelectChange("car_types", selectedOptions);
              }}
              value={form?.car_types}
            />
          </div>
          {/* insurances multi-select */}
          <div className="w-full">
            <label className="textgray font-light mb-2">ประกันภัย</label>

            <MultiSelect
              option={insurances}
              onChange={(selectedOptions) => {
                handleSelectChange("insurances", selectedOptions);
              }}
              value={form?.insurances}
            />
          </div>
          {/* province, district, sub_district, postcode */}
          <div className="w-full">
            <label className="textgray font-light mb-2">จังหวัด</label>
            <SingleSelect
              option={provinceOption}
              onChange={(selectedOption) => {
                handleSelectChange("province", selectedOption.value);
                const newDistricts = districtOption?.filter(
                  (item) =>
                    item?.province_code === selectedOption?.province_code
                );
                setFilteredDistricts(newDistricts);
                setFilteredSubDistricts([]);
                setFilteredPostcodes([]);
              }}
              value={
                provinceOption?.find(
                  (option) => option?.value === form?.province
                ) || null
              }
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">อำเภอ/เขต</label>
            <SingleSelect
              option={filteredDistricts}
              onChange={(selectedOption) => {
                handleSelectChange("district", selectedOption.value);
                const newSubDistricts = subDistrictOption?.filter(
                  (item) =>
                    item?.district_code === selectedOption?.district_code
                );
                setFilteredSubDistricts(newSubDistricts);
                setFilteredPostcodes([]);
              }}
              value={
                districtOption?.find(
                  (option) => option?.value === form?.district
                ) || null
              }
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">แขวง/ตำบล</label>
            <SingleSelect
              option={filteredSubDistricts}
              onChange={(selectedOption) => {
                handleSelectChange("sub_district", selectedOption.value);
                const newPostcodes = postcodeOption?.filter(
                  (item) =>
                    item?.sub_district_code ===
                    selectedOption?.sub_district_code
                );
                setFilteredPostcodes(newPostcodes);
                console.log("newPostcodes", newPostcodes);
              }}
              value={
                subDistrictOption?.find(
                  (option) => option?.value === form?.sub_district
                ) || null
              }
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">รหัสไปรษณีย์</label>

            <SingleSelect
              option={filteredPostcodes}
              onChange={(selectedOption) => {
                handleSelectChange("postcode", selectedOption.value);
              }}
              value={
                postcodeOption?.find(
                  (option) => option?.value == form?.postcode
                ) || null
              }
            />
          </div>
          <div className="w-full">
            <label className="textgray font-light mb-2">ที่อยู่</label>
            <input
              name="address"
              type="text"
              value={form?.address}
              onChange={handleChange}
              className="border border-yellowbutton w-full h-8 rounded-md mb-4 p-4"
            />
          </div>
          {/* cradle_image_cover */}
          <div className="w-full">
            <label className="textgray font-light mb-2">File (รูปปก)</label>

            <img
              src={getImgSrc(form?.cradle_image_cover)}
              alt="Cradle Cover"
              className="w-[800px] h-[400px] object-cover mb-2"
            />
            <input
              name="cradle_image_cover"
              type="file"
              onChange={handleFileChange}
              className="mt-4 p-0.5 cursor-pointer flex justify-center font-light items-center w-40 border border-green-700 hover:border-green-500 hover:bg-green-500 text-green-700 hover:text-white rounded-full duration-300"
            />
          </div>
          {/* images_gallery array */}
          <div className="w-full">
            <label className="textgray font-light mb-2">File (เพิ่มเติม)</label>
            {form?.images_gallery?.map((img, idx) => (
              <div key={idx} className="flex items-center gap-2 mt-2">
                <img
                  src={getImgSrc(
                    form?.images_gallery?.[idx]?.this_images_gallery
                  )}
                  alt="Gallery"
                  className="w-[800px] h-[400px] object-cover mb-2"
                />
                <input
                  type="file"
                  onChange={(e) =>
                    handleGalleryFileChange(idx, e.target?.files?.[0])
                  }
                  className="mt-4 p-0.5 cursor-pointer flex justify-center font-light items-center w-40 border border-green-700 hover:border-green-500 hover:bg-green-500 text-green-700 hover:text-white rounded-full duration-300"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveGallery(idx)}
                  className="mt-4 border border-red-700 hover:border-red-500 hover:bg-red-500 rounded-full text-center text-red-500 hover:text-white w-40 cursor-pointer"
                >
                  ลบ
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={handleAddGallery}
              className="mt-4 bg-blue-500 hover:bg-blue-400 px-4 py-1 text-white hover:text-blueGray rounded-full text-center w-40 cursor-pointer"
            >
              เพิ่มรูป
            </button>
          </div>
          {/* ปุ่ม submit/cancel */}
          <div className="flex gap-3 mt-6">
            <button
              type="submit"
              className="p-0.5 cursor-pointer flex justify-center font-light items-center gap-2 w-auto border border-green-700 hover:border-green-500 hover:bg-green-500 text-green-700 hover:text-white rounded-full duration-300"
              onClick={handleSubmit}
            >
              บันทึก
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="p-0.5 cursor-pointer flex justify-center items-center gap-2 w-40 border border-red-700 hover:border-red-500 hover:bg-red-500 text-red-700 hover:text-white rounded-full duration-300"
            >
              ยกเลิก
            </button>
          </div>
        </form>
      </div>
      <div className="grid grid-cols-2 col-span-4"></div>
    </ContainerContent>
  );
};
export default AddCradle;
